import { PageRef } from 'providers/page-ref';

export type FoodsPageParams = {
  mode: 'select' | 'list' | '';
  gotoLogFoodAfterSelect_dayDate?: string; // date for the log food page to open after selection
  filter?: string;
  barcodeSearch?: string; // barcode to search for (from barcode scanner)
  returnCallback?: string; // method name on parent page to call with result
  /**
   * Stay open when a food is picked, instead of closing to answer (#4967).
   *
   * Off by default, so every existing caller keeps the old behaviour. Callers that turn it
   * on are the ones whose next step is the portion screen: the result still reaches the same
   * `returnCallback`, but this list stays underneath, so logging the food comes back HERE and
   * the next food is one tap away. Opt-in rather than automatic because a caller whose
   * callback assumes this page has gone would break — see `design-docs/navigation.md`.
   */
  keepOpenAfterSelect?: boolean;
  openBarcodeScanner?: boolean;
  initialSearchText?: string; // pre-fill search text (e.g. from meal photo scanner)
  local?: {
    returnContext?: unknown; // context passed back to parent
  };
};

export type FoodsPageResult =
  | { action: 'select'; foodId: string }
  | { action: 'addMacros' };

export const IFoodsPage: PageRef<FoodsPageParams, FoodsPageResult> = {
  pageName: 'FoodsPage',
} as PageRef<FoodsPageParams, FoodsPageResult>;
